import { render, staticRenderFns } from "./Rulements.vue?vue&type=template&id=2c827f36&scoped=true"
import script from "./Rulements.vue?vue&type=script&lang=js"
export * from "./Rulements.vue?vue&type=script&lang=js"
import style0 from "./Rulements.vue?vue&type=style&index=0&id=2c827f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c827f36",
  null
  
)

export default component.exports